/*  ========================================================================
    # Hooks - Use Breakpoints
    ========================================================================  */

import { useEffect, useState } from 'react';
import { breakpoints } from '../helpers/breakpoints';

const useBreakpoints = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const handleResize = () => setViewportWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window, handleResize]);

  // Up
  const upMatches = {
    smUp: viewportWidth >= breakpoints.sm,
    mdUp: viewportWidth >= breakpoints.md,
    lgUp: viewportWidth >= breakpoints.lg,
    xlUp: viewportWidth >= breakpoints.xl,
    xxlUp: viewportWidth >= breakpoints.xxl,
    xxxlUp: viewportWidth >= breakpoints.xxxl
  };

  // Down
  const downMatches = {
    smDown: viewportWidth < breakpoints.md,
    mdDown: viewportWidth < breakpoints.lg,
    lgDown: viewportWidth < breakpoints.xl,
    xlDown: viewportWidth < breakpoints.xxl,
    xxlDown: viewportWidth < breakpoints.xxxl
  };

  // Exact
  const exactMatches = {
    xs: !upMatches.smUp,
    sm: upMatches.smUp && downMatches.smDown,
    md: upMatches.mdUp && downMatches.mdDown,
    lg: upMatches.lgUp && downMatches.lgDown,
    xl: upMatches.xlUp && downMatches.xlDown,
    xxl: !downMatches.xlDown
  };

  return { ...upMatches, ...downMatches, ...exactMatches, viewportWidth };
};

export default useBreakpoints;
